import { AppRoutesUI } from "./appRoutes";
import TreeIcon from "@rsuite/icons/Tree";
import GlobalIcon from "@rsuite/icons/Global";
import FileUploadIcon from "@rsuite/icons/FileUpload";
import TextImageIcon from "@rsuite/icons/TextImage";
import PageIcon from "@rsuite/icons/Page";
import { Dashboard } from "@rsuite/icons";
import ChangeListIcon from '@rsuite/icons/ChangeList';
import PieChartIcon from '@rsuite/icons/PieChart';
import DetailIcon from '@rsuite/icons/Detail';
import ImportIcon from '@rsuite/icons/Import';

export const navLinks = [
  {
    name: "Home",
    icon: <Dashboard />,
    link: AppRoutesUI.Home.Path(),
    route: AppRoutesUI.Home.Route,
  },
  {
    name: "Category",
    icon: <TreeIcon />,
    link: AppRoutesUI.Category.Path(),
    route: AppRoutesUI.Category.Route,
  },
  {
    name: "Country Region",
    icon: <GlobalIcon />,
    link: AppRoutesUI.CountryRegion.Path(),
    route: AppRoutesUI.CountryRegion.Route,
  },
  {
    name: "Content Upload",
    icon: <FileUploadIcon />,
    link: AppRoutesUI.ContentUpload.Path(),
    route: AppRoutesUI.ContentUpload.Route,
  },
  {
    name: "Forms",
    icon: <TextImageIcon />,
    link: AppRoutesUI.Forms.Path(),
    route: AppRoutesUI.Forms.Route,
  },
  {
    name: "Regulations",
    icon: <PageIcon />,
    link: AppRoutesUI.Regulations.Path(),
    route: AppRoutesUI.Regulations.Route,
  },
  {
    name: "NewsAgreegator",
    icon: <ChangeListIcon />,
    link: AppRoutesUI.NewsAggregator.Path(),
    route: AppRoutesUI.NewsAggregator.Route,
  },
  {
    name: "MLI Data",
    icon: <PieChartIcon />,
    link: AppRoutesUI.MLIDataUploader.Path(),
    route: AppRoutesUI.MLIDataUploader.Route,
  },
  {
    name: "Pillar Two News Mapper",
    icon: <DetailIcon />,
    link: AppRoutesUI.PillarTwoNewsMapper.Path(),
    route: AppRoutesUI.PillarTwoNewsMapper.Route,
  },
  {
    name: "Provider News",
    icon: <ImportIcon />,
    link: AppRoutesUI.ProviderNews.Path(),
    route: AppRoutesUI.ProviderNews.Route,
  }
];
